import './getCopy.css';
import amazonLogo from '../../assets/Amazon-Logo.png';
import kindleLogo from '../../assets/kindle-smile-logo.png';
import audibleLogo from '../../assets/Audible-Logo.png';
import gumroadLogo from '../../assets/gumroadlogo.png';

function GetYourCopy({ localOnly = false, stores = {}, libraries = [] }) {
  const {
    amazon = null,
    kindle = null,
    audible = null,
    gumroad = null,
  } = stores;

  return (
    <section className="get-copy">
      <div className="get-copy-card">
        <h2>Get Your Copy Today...</h2>

        {/* Online stores — Gumroad always shows, others respect localOnly */}
        {((!localOnly && (amazon || kindle || audible)) || gumroad) && (
          <div className="store-row">
            {!localOnly && amazon && (
              <a href={amazon} className="store-btn amazon" target="_blank" rel="noopener noreferrer">
                <img src={amazonLogo} alt="Amazon" />
              </a>
            )}
            {!localOnly && kindle && (
              <a href={kindle} className="store-btn kindle" target="_blank" rel="noopener noreferrer">
                <img src={kindleLogo} alt="Kindle" />
              </a>
            )}
            {!localOnly && audible && (
              <a href={audible} className="store-btn audible" target="_blank" rel="noopener noreferrer">
                <img src={audibleLogo} alt="Audible" />
              </a>
            )}
            {gumroad && (
              <a href={gumroad} className="store-btn gumroad" target="_blank" rel="noopener noreferrer">
                <img src={gumroadLogo} alt="Gumroad" />
              </a>
            )}
          </div>
        )}

        {/* Local libraries */}
        {libraries.length > 0 && (
          <>
            <h3 className="local-heading">Local Libraries in Algeria</h3>
            <div className="library-row">
              {libraries.map((lib, i) => (
                <a
                  key={i}
                  href={lib.url}
                  className={`library-btn ${lib.style || 'library-brown'}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {lib.name}
                </a>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}

export default GetYourCopy;